var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompanyIconPricebooks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0E141A",
  d: "M2 18q-.824 0-1.412-.587A1.93 1.93 0 0 1 0 16V2Q0 1.175.588.587A1.93 1.93 0 0 1 2 0h6q.825 0 1.413.587Q10 1.175 10 2v2h8q.825 0 1.413.587Q20 5.175 20 6v10q0 .825-.587 1.413A1.93 1.93 0 0 1 18 18zm0-2h6v-2H2zm0-4h6v-2H2zm0-4h6V6H2zm0-4h6V2H2zm8 12h8V6h-8zm2-6V8h4v2zm0 4v-2h4v2z"
})));
export { SvgCompanyIconPricebooks as ReactComponent };
export default __webpack_public_path__ + "static/media/company-icon-pricebooks.896570b6.svg";